export const NO_SIGNATURE_DATA_URL = 'data:image/svg+xml;utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22140%22%20height%3D%2240%22%20viewBox%3D%220%200%20140%2040%22%3E%3Ctext%20x%3D%2270%22%20y%3D%2224%22%20fill%3D%22%23555555%22%20font-family%3D%22Arial%2C%20Helvetica%2C%20sans-serif%22%20font-size%3D%2213%22%20text-anchor%3D%22middle%22%3ENo%20Signature%3C%2Ftext%3E%3C%2Fsvg%3E';
export const NO_THUMB_DATA_URL = 'data:image/svg+xml;utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2280%22%20height%3D%2280%22%20viewBox%3D%220%200%2080%2080%22%3E%3Ctext%20x%3D%2240%22%20y%3D%2244%22%20fill%3D%22%23555555%22%20font-family%3D%22Arial%2C%20Helvetica%2C%20sans-serif%22%20font-size%3D%2213%22%20text-anchor%3D%22middle%22%3ENo%20Thumb%3C%2Ftext%3E%3C%2Fsvg%3E';

// app/javascript/components/UserManagement.jsx
import React, { useState, useEffect, useMemo, useRef } from 'react';
import { t } from '../utils/i18n';
import { toSomaliDept, toEnglishDept, getAllDeptSynonyms } from '../utils/deptTranslations';
import { useArmyDepartments, getStructureKeyForForce, ARMY_STRUCTURE } from '../hooks/useArmyDepartments';
import QRCode from 'qrcode';
import JsBarcode from 'jsbarcode';
import CommonModal from './Modal';
import BulkUpdateModal from './BulkUpdateModal';
import Pagination from './Pagination';
import { useDatepicker } from '../hooks/useDatepicker';
import PersonnelViewModal from './PersonnelViewModal';
import { hasRole } from '../utils/roleHelper';
import { getScopedTemplateCss, ID_CARD_SCOPE_CLASS } from '../utils/scopeCss';

const PersonnelManagement = ({ onBack, onNavigate, api, subView = 'military', user }) => {
  useDatepicker();
  const isPersonnelViewer = hasRole(user, 'personnel_viewer');
  const fetchUsersRequestId = useRef(0);
  const [users, setUsers] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);
  const [sortBy, setSortBy] = useState('email-asc');
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [showIdModal, setShowIdModal] = useState(false);
  const [idCardQrUrl, setIdCardQrUrl] = useState('');
  const [idCardBarcodeUrl, setIdCardBarcodeUrl] = useState('');
  const [showBulkModal, setShowBulkModal] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectByStatusDropdownOpen, setSelectByStatusDropdownOpen] = useState(false);
  const [statusDropdownOpen, setStatusDropdownOpen] = useState(false);
  const [showExportModal, setShowExportModal] = useState(false);

  const armyTypeMap = useMemo(() => ({
    'military': 'Puntland Military Force',
    'police': 'Puntland Police Force',
    'discipline': 'Puntland Custodial Corps (Asluubta)'
  }), []);

  const [filters, setFilters] = useState({
    email: '',
    full_name: '',
    phone: '',
    department: '',
    subDepartment: '',
    organization: '',
    title: '',
    equipment: '',
    region: '',
    district: '',
    station: '',
    rank: '',
    status: '',
    fromDate: '',
    toDate: ''
  });
  const [showFilters, setShowFilters] = useState(false);
  const [locations, setLocations] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(25);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [perPageDropdownOpen, setPerPageDropdownOpen] = useState(false);
  const [idCardAssignment, setIdCardAssignment] = useState(null);
  const [showViewModal, setShowViewModal] = useState(false);
  const [viewModalUser, setViewModalUser] = useState(null);
  const [idCardSide, setIdCardSide] = useState('front');

  // State for row actions dropdown
  const [openActionDropdownId, setOpenActionDropdownId] = useState(null);

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (!e.target.closest('.actions-dropdown-container')) {
        setOpenActionDropdownId(null);
      }
    };
    document.addEventListener('click', handleOutsideClick);
    return () => document.removeEventListener('click', handleOutsideClick);
  }, []);


  const [exportColumns, setExportColumns] = useState({
    id: true,
    full_name: true,
    mother_name: true,
    place_of_birth: true,
    gender: true,
    marital_status: true,
    birth_date: true,
    blood_type: true,
    phone: true,
    status: true,
    educational_level: true,
    email: true,
    organization: true,
    prev_data: true,
    work_place: true,
    address: true,
    emergency_contact: true,
    emergency_contact_phone: true,
    emergency_contact_relation: true,
    responsible_person_name: true,
    responsible_person_phone: true,
    army_type: true,
    army_department: true,
    sub_department: true,
    rank: true,
    title: true,
    bank_account: true,
    salary_usd: true,
    allowance_usd: true,
    training: true,
    remarks: true,
    army_equipment: true,
    district: true,
    region: true,
    station: true,
    biometric_enrolled_count: true,
    fingerprints_data: true,
    synced_to_web: true,
    sync_date: true,
    created_at: true
  });

  useEffect(() => {
    if (idCardAssignment) {
      const payload = idCardAssignment.render_payload || {};
      const ap = idCardAssignment.army_personnel || {};
      const armyId = payload.army_id || ap.user?.army_id || ap.army_id || "";
      const forceName = payload.army_type || ap.army_type?.name || "Puntland Armed Forces";
      const fullName = payload.full_name || ap.full_name || "";
      const rankName = payload.rank || ap.rank || "";
      const subDeptName = payload.sub_department || ap.sub_department?.name || "";
      const bloodTypeStr = payload.blood_type || ap.blood_type || "";
      const issueDateStr = payload.issue_date || (idCardAssignment.issue_date ? new Date(idCardAssignment.issue_date).toLocaleDateString() : "");
      const expiryDateStr = payload.expiry_date || (idCardAssignment.expiry_date ? new Date(idCardAssignment.expiry_date).toLocaleDateString() : "");

      if (armyId && armyId !== "N/A") {
        const qrPayload = [
          `PUNTLAND STATE - ${forceName.toUpperCase()}`,
          `ID: ${armyId}`,
          `Name: ${fullName}`,
          `Rank: ${rankName}`,
          `Department: ${subDeptName}`,
          `Blood Type: ${bloodTypeStr}`,
          `Issue Date: ${issueDateStr}`,
          `Expiry Date: ${expiryDateStr}`
        ].join("\n");

        QRCode.toDataURL(qrPayload, { margin: 1, width: 160 })
          .then(url => setIdCardQrUrl(url))
          .catch(err => console.error("Error generating QR code:", err));

        try {
          const canvas = document.createElement("canvas");
          JsBarcode(canvas, armyId, {
            format: "CODE128",
            width: 2,
            height: 50,
            displayValue: true,
            fontSize: 12,
            margin: 2,
            background: "rgba(0,0,0,0)",
            lineColor: "#000000"
          });
          setIdCardBarcodeUrl(canvas.toDataURL("image/png"));
        } catch (err) {
          console.error("Error generating barcode:", err);
        }
      }
    }
  }, [idCardAssignment]);

  const generateIdCardHtml = (templateField, armyPersonnel, payload = {}, idCardTemplate, qrCodeOverride, barcodeOverride) => {
    let htmlContent = idCardTemplate[templateField] || "";
    if (!htmlContent) return "";

    htmlContent = htmlContent.replace(/(src|href)=["\x27]\.\/images\//gi, "$1=\"/images/");

    const photoSrc = payload.photo_url || (armyPersonnel.army_photo
      ? (armyPersonnel.army_photo.startsWith("data:") || armyPersonnel.army_photo.startsWith("http") || (armyPersonnel.army_photo.startsWith("/") && !armyPersonnel.army_photo.startsWith("/9j/"))
        ? armyPersonnel.army_photo
        : `data:image/jpeg;base64,${armyPersonnel.army_photo}`)
      : "/images/solider.png");

    const signatureSrc = payload.signature_url || (() => {
      const sigBio = (armyPersonnel.biometric_data || []).find(b => b.biometric_type === "signature" || b.biometric_type === 1 || b.biometric_type === "1");
      if (sigBio?.data) {
        const cleaned = sigBio.data.trim();
        if (cleaned.startsWith("data:") || cleaned.startsWith("http") || cleaned.startsWith("/")) return cleaned;
        return `data:image/png;base64,${cleaned}`;
      }
      return NO_SIGNATURE_DATA_URL;
    })();

    const thumbprintSrc = payload.thumbprint_url || (() => {
  const fpBio = (armyPersonnel.biometric_data || []).find(b => b.biometric_type === "fingerprint" || b.biometric_type === 0 || b.biometric_type === "0");
  if (fpBio?.data) {
    const candidate = fpBio.data.trim();
    if (candidate.startsWith("data:") || candidate.startsWith("http") || candidate.startsWith("/")) return candidate;
    if (candidate.startsWith("iVBOR")) return `data:image/png;base64,${candidate}`;
    if (candidate.startsWith("/9j/")) return `data:image/jpeg;base64,${candidate}`;
    if (candidate.startsWith("Qk0") || candidate.startsWith("Qk1") || candidate.startsWith("Qk2") || candidate.startsWith("Qk")) return `data:image/bmp;base64,${candidate}`;
    if (candidate.startsWith("R0lGOD")) return `data:image/gif;base64,${candidate}`;
  }
  return NO_THUMB_DATA_URL;
})();

    const armyId = payload.army_id || armyPersonnel.user?.army_id || armyPersonnel.army_id || "";
    const fullName = payload.full_name || armyPersonnel.full_name || "";
    const rankName = payload.rank || armyPersonnel.rank || "";
    const subDeptName = payload.sub_department || armyPersonnel.sub_department?.name || "";
    const forceName = payload.army_type || armyPersonnel.army_type?.name || "CIIDAMADA DIFAACA PUNTLAND";
    const qrUrl = qrCodeOverride !== undefined ? qrCodeOverride : (idCardQrUrl || "");
    const barcodeUrl = barcodeOverride !== undefined ? barcodeOverride : (idCardBarcodeUrl || "");

    const replacements = {
      "army_id": armyId,
      "id": armyId,
      "full_name": fullName,
      "name": fullName,
      "date_of_birth": payload.date_of_birth || (armyPersonnel.birth_date ? new Date(armyPersonnel.birth_date).toLocaleDateString() : ""),
      "dob": payload.date_of_birth || (armyPersonnel.birth_date ? new Date(armyPersonnel.birth_date).toLocaleDateString() : ""),
      "place_of_birth": payload.place_of_birth || armyPersonnel.place_of_birth || "",
      "pob": payload.place_of_birth || armyPersonnel.place_of_birth || "",
      "blood_type": payload.blood_type || armyPersonnel.blood_type || "",
      "rank": rankName,
      "title": payload.title || armyPersonnel.title || rankName,
      "sub_department": subDeptName,
      "department": payload.department || armyPersonnel.department?.name || subDeptName,
      "division": payload.division || subDeptName || armyPersonnel.department?.name || "",
      "organization_unit": payload.organization_unit || subDeptName || "1aad – Taliska Guud",
      "organization": payload.organization || forceName,
      "issue_date": payload.issue_date || (idCardAssignment?.issue_date ? new Date(idCardAssignment.issue_date).toLocaleDateString() : ""),
      "expiry_date": payload.expiry_date || (idCardAssignment?.expiry_date ? new Date(idCardAssignment.expiry_date).toLocaleDateString() : ""),
      "serial_number": payload.serial_number || (armyId ? armyId.replace(/[^0-9]/g, "") : "") || "",
      "photo_url": photoSrc,
      "signature_url": signatureSrc,
      "commander_signature_url": payload.commander_signature_url || (/police/i.test(forceName) ? "/images/sig.jpg" : "/images/pmfc-signature.jpg"),
      "thumbprint_url": thumbprintSrc,
      "logo_url": payload.logo_url || "/images/logo.png",
      "qr_code": qrUrl,
      "barcode": barcodeUrl,
      "army_type": forceName,
      "biometric_status": payload.biometric_status || "Enrolled",
      "return_notice": payload.return_notice || "Haddii kaarkan la helo, fadlan u celi xafiiska dawladda ama xerada ciidanka ee ugu dhow.",
      "border_text": payload.border_text || (/police/i.test(forceName) ? "PUNTLAND POLICE FORCE • CIIDANKA BOOLISKA PUNTLAND" : /darawiish|military/i.test(forceName) ? "PUNTLAND DARAWIISH FORCE • CIIDANKA DARAWIISHTA PUNTLAND" : "PUNTLAND CUSTODIAL CORPS • CIIDANKA ASLUUBTA PUNTLAND"),
      "contact_email": payload.contact_email || (/police/i.test(forceName) ? "info@police.pl.so" : /darawiish|military/i.test(forceName) ? "info@darawiish.pl.so" : "info@asluubta.pl.so"),
      "hotline": payload.hotline || (/police/i.test(forceName) ? "999" : "888"),
      "coat_of_arms_url": payload.coat_of_arms_url || "/images/pmfc-coat-of-arms.png"
    };

    Object.entries(replacements).forEach(([key, value]) => {
      const re = new RegExp(`{{\s*${key}\s*}}`, "gi");
      htmlContent = htmlContent.replace(re, value == null ? "" : value);
    });
    // Fallback safety for any remaining image tags
    htmlContent = htmlContent.replace(/{{\s*signature_url\s*}}/gi, signatureSrc || NO_SIGNATURE_DATA_URL);
    htmlContent = htmlContent.replace(/{{\s*thumbprint_url\s*}}/gi, thumbprintSrc || NO_THUMB_DATA_URL);
    htmlContent = htmlContent.replace(/{{\s*commander_signature_url\s*}}/gi, payload.commander_signature_url || (/police/i.test(forceName) ? "/images/sig.jpg" : "/images/pmfc-signature.jpg"));
    htmlContent = htmlContent.replace(/{{\s*photo_url\s*}}/gi, photoSrc || "/images/solider.png");
    return htmlContent;
  };

  const DynamicIdCard = ({ assignment, side = 'front' }) => {
    if (!assignment?.id_card_template) return <div>No template assigned</div>;

    const { army_personnel, id_card_template } = assignment;
    const payload = assignment.render_payload || {};
    const templateField = side === 'back' ? 'back_template_data' : 'template_data';
    const htmlContent = generateIdCardHtml(templateField, army_personnel, payload, id_card_template);
    if (!htmlContent) return <div>No template data available for {side} side</div>;

const scopedCss = getScopedTemplateCss(id_card_template.css_styles || "");

return (
  <div className={ID_CARD_SCOPE_CLASS} style={{ display: "inline-block", width: "100%" }}>
    <style dangerouslySetInnerHTML={{ __html: scopedCss }} />
    <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
  </div>
);
  };

  const handleBulkSubmit = async ({ fieldName, oldValue, newValue }) => {
    try {
      const response = await api.post('/army_personnel/bulk_update', {
        field_name: fieldName,
        old_value: oldValue,
        new_value: newValue
      });
      alert(`Successfully updated ${response.data.updated_count || 0} records`);
      setShowBulkModal(false);
      fetchUsers();
    } catch (err) {
      console.error(err);
      alert(err.response?.data?.error || 'Bulk update failed');
    }
  };

  const handleShowId = async (user) => {
    if (!user.army_personnel?.id) {
      alert('No personnel record found');
      return;
    }

    try {
      const response = await api.get(`/id_card_assignments?army_personnel_id=${user.army_personnel.id}`);
      const assignments = response.data?.data || [];
      if (assignments.length > 0) {
        setIdCardAssignment(assignments[0]);
        setShowIdModal(true);
      } else {
        alert('No ID card assigned to this personnel');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('No ID card template assigned to this personnel');
    }
  };

  const handlePrint = () => {
    if (!idCardAssignment) return;

    const { army_personnel, id_card_template } = idCardAssignment;
    const payload = idCardAssignment.render_payload || {};

    const frontHtml = generateIdCardHtml('template_data', army_personnel, payload, id_card_template);
    const backHtml = generateIdCardHtml('back_template_data', army_personnel, payload, id_card_template);

    const printWindow = window.open('', '_blank');
    printWindow.document.write(`
      <html>
        <head>
          <title>ID Card</title>
          <style>
            * {
              margin: 0;
              padding: 0;
              box-sizing: border-box;
            }
            @page {
              size: A4 portrait;
              margin: 0.5cm;
            }
            @media print {
              html, body {
                margin: 0;
                padding: 0;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
              }
              .cards-container {
                page-break-inside: avoid;
              }
            }
            body {
              margin: 0;
              padding: 0.5cm;
              font-family: Arial, sans-serif;
              background: white;
            }
            .cards-container {
              display: flex;
              gap: 15px;
              justify-content: center;
              align-items: center;
              width: 100%;
              page-break-inside: avoid;
            }
            .card-wrapper {
              flex: 0 0 auto;
              width: 45%;
              height: auto;
              aspect-ratio: 1012 / 638;
              border: 1px solid #999;
              display: flex;
              align-items: center;
              justify-content: center;
              overflow: hidden;
              background: white;
            }
            .card-content {
              width: 100%;
              height: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
            }
            .cardlogo {
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
              height: 100%;
              margin-left: -20px;
            }
            ${getScopedTemplateCss(id_card_template.css_styles || '')}
          </style>
        </head>
        <body>
          <div class="cards-container ${ID_CARD_SCOPE_CLASS}">
            <div class="card-wrapper">
              <div class="card-content">${frontHtml}</div>
            </div>
            ${backHtml ? `<div class="card-wrapper"><div class="card-content">${backHtml}</div></div>` : ''}
          </div>
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.onload = () => {
      setTimeout(() => {
        printWindow.print();
      }, 800);
    };
  };

  const handleDownload = () => {
    if (!idCardAssignment) return;

    const { army_personnel, id_card_template } = idCardAssignment;
    const payload = idCardAssignment.render_payload || {};

    const frontHtml = generateIdCardHtml('template_data', army_personnel, payload, id_card_template);
    const backHtml = generateIdCardHtml('back_template_data', army_personnel, payload, id_card_template);

    const htmlContent = `
      <html>
        <head>
          <title>ID Card</title>
          <script src="https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.10.1/html2pdf.bundle.min.js"></script>
          <style>
            * {
              margin: 0;
              padding: 0;
              box-sizing: border-box;
            }
            @page {
              size: A4 portrait;
              margin: 0.5cm;
            }
            body {
              margin: 0;
              padding: 0.5cm;
              font-family: Arial, sans-serif;
              background: white;
            }
            .cards-container {
              display: flex;
              gap: 15px;
              justify-content: center;
              align-items: center;
              width: 100%;
              page-break-inside: avoid;
            }
            .card-wrapper {
              flex: 0 0 auto;
              width: 45%;
              height: auto;
              aspect-ratio: 1012 / 638;
              border: 1px solid #999;
              display: flex;
              align-items: center;
              justify-content: center;
              overflow: hidden;
              background: white;
            }
            .card-content {
              width: 100%;
              height: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
            }
            .cardlogo {
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
              height: 100%;
              margin-left: -20px;
            }
            ${getScopedTemplateCss(id_card_template.css_styles || '')}
          </style>
        </head>
        <body>
          <div id="pdf-content">
            <div class="cards-container ${ID_CARD_SCOPE_CLASS}">
              <div class="card-wrapper">
                <div class="card-content">${frontHtml}</div>
              </div>
              ${backHtml ? `<div class="card-wrapper"><div class="card-content">${backHtml}</div></div>` : ''}
            </div>
          </div>
          <script>
            const element = document.getElementById('pdf-content');
            const opt = {
              margin: 5,
              filename: 'id-card-${army_personnel.full_name}.pdf',
              image: { type: 'jpeg', quality: 0.98 },
              html2canvas: { scale: 2 },
              jsPDF: { format: 'a4', orientation: 'portrait' }
            };
            html2pdf().set(opt).from(element).save();
          </script>
        </body>
      </html>
    `;

    const blob = new Blob([htmlContent], { type: 'text/html' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.target = '_blank';
    a.click();
  };

  const currentForce = (subView && armyTypeMap[subView]) ? armyTypeMap[subView] : '';
  const {
    armyTypes,
    departments,
    filteredDepartments,
    filteredSubDepartments,
    handleDepartmentChange,
  } = useArmyDepartments(api, currentForce, filters.department);

  // When switching force via sidebar, reset department and sub-department filters
  useEffect(() => {
    setFilters(prev => ({
      ...prev,
      department: '',
      subDepartment: ''
    }));
    handleDepartmentChange('');
  }, [subView]);

  useEffect(() => {
    const delaySearch = setTimeout(() => {
      fetchUsers();
    }, 300);
    return () => clearTimeout(delaySearch);
  }, [
    currentPage, sortBy, subView, itemsPerPage, refreshKey,
    filters.email, filters.full_name, filters.phone,
    filters.department, filters.subDepartment, filters.organization, filters.title,
    filters.equipment, filters.region, filters.district, filters.rank, filters.status,
    filters.fromDate, filters.toDate, filters.station
  ]);

  // Refetch when the browser tab regains focus (e.g. user switches back after resyncing from desktop)
  useEffect(() => {
    const handleFocus = () => setRefreshKey(k => k + 1);
    window.addEventListener('focus', handleFocus);
    return () => window.removeEventListener('focus', handleFocus);
  }, []);

  useEffect(() => {
    fetchFilterOptions();
  }, []);

  const fetchFilterOptions = async () => {
    try {
      const locData = await api.get('/locations');
      setLocations(locData || []);
    } catch (err) {
      console.error('Failed to fetch filter options');
    }
  };

  const handleDepartmentFilterChange = (deptValue) => {
    setFilters(prev => ({
      ...prev,
      department: deptValue,
      subDepartment: ''
    }));
    handleDepartmentChange(deptValue);
    setCurrentPage(1);
  };

  const handleSubDepartmentFilterChange = (subDeptValue) => {
    setFilters(prev => ({
      ...prev,
      subDepartment: subDeptValue
    }));
    setCurrentPage(1);
  };

  const handleFilterChange = (field, value) => {
    setFilters(prev => ({ ...prev, [field]: value }));
    setCurrentPage(1);
  };

  const handleClearFilters = () => {
    setFilters({
      email: '',
      full_name: '',
      phone: '',
      department: '',
      subDepartment: '',
      organization: '',
      title: '',
      equipment: '',
      region: '',
      district: '',
      station: '',
      rank: '',
      status: '',
      fromDate: '',
      toDate: ''
    });
    handleDepartmentChange('');
    setCurrentPage(1);
  };

  useEffect(() => {
    if (!showFilters) return;

    const initializeDatePickers = () => {
      const checkAndInit = () => {
        if (window.$ && window.$.fn.datepicker &&
          document.getElementById('fromDateFilter') &&
          document.getElementById('toDateFilter')) {

          console.log('Initializing date pickers');

          // Destroy existing datepickers first
          $('#fromDateFilter').datepicker('destroy');
          $('#toDateFilter').datepicker('destroy');

          // Initialize From Date picker
          $('#fromDateFilter').datepicker({
            dateFormat: 'yy-mm-dd',
            changeMonth: true,
            changeYear: true,
            onSelect: function (dateText) {
              console.log('From date selected:', dateText);
              handleFilterChange('fromDate', dateText);

              // Update To Date picker's minDate constraint
              $('#toDateFilter').datepicker('option', 'minDate', dateText);

              // Re-focus on To Date picker for better UX
              setTimeout(() => {
                $('#toDateFilter').focus();
              }, 100);
            }
          });

          // Initialize To Date picker
          $('#toDateFilter').datepicker({
            dateFormat: 'yy-mm-dd',
            changeMonth: true,
            changeYear: true,
            minDate: filters.fromDate || null, // Set initial constraint if fromDate exists
            onSelect: function (dateText) {
              console.log('To date selected:', dateText);
              handleFilterChange('toDate', dateText);

              // Update From Date picker's maxDate constraint
              $('#fromDateFilter').datepicker('option', 'maxDate', dateText);
            }
          });

          // Set initial constraints if dates already exist
          if (filters.fromDate) {
            $('#toDateFilter').datepicker('option', 'minDate', filters.fromDate);
          }
          if (filters.toDate) {
            $('#fromDateFilter').datepicker('option', 'maxDate', filters.toDate);
          }

        } else {
          console.log('jQuery datepicker or DOM elements not ready, retrying...');
          setTimeout(checkAndInit, 100);
        }
      };

      checkAndInit();
    };

    const timer = setTimeout(initializeDatePickers, 100);
    return () => clearTimeout(timer);

  }, [showFilters, users?.length, filters.fromDate, filters.toDate]);


  const fetchUsers = async () => {
    const requestId = ++fetchUsersRequestId.current;
    setLoading(true);
    try {
      const [field, order] = sortBy.split('-');
      const params = new URLSearchParams({
        personnel: 'true',
        page: currentPage,
        per_page: itemsPerPage === 'all' ? totalCount || 10000 : itemsPerPage,
        'q[s]': `${field} ${order}`
      });

      let currentArmyTypeId = null;
      let atRecord = null;
      const effectiveForce = (subView && armyTypeMap[subView]) ? armyTypeMap[subView] : '';
      if (effectiveForce && effectiveForce !== 'all') {
        atRecord = armyTypes.find(a =>
          String(a.id) === String(effectiveForce) ||
          a.name?.toLowerCase() === effectiveForce.toLowerCase() ||
          getStructureKeyForForce(a.name, armyTypes) === getStructureKeyForForce(effectiveForce, armyTypes)
        );
        if (atRecord) {
          currentArmyTypeId = String(atRecord.id);
          params.append('q[army_personnel_army_type_id_eq]', atRecord.id);
        } else {
          params.append('q[army_personnel_army_type_name_cont]', effectiveForce);
        }
      }

      // Apply filters
      if (filters.email) params.append('q[email_cont]', filters.email);
      if (filters.full_name) params.append('q[army_personnel_full_name_cont]', filters.full_name);
      if (filters.phone) params.append('q[army_personnel_phone_cont]', filters.phone);

      if (filters.department) {
        params.append('department_name', filters.department);
        if (filters.subDepartment) {
          params.append('sub_department_name', filters.subDepartment);
        }
      } else if (filters.subDepartment) {
        params.append('sub_department_name', filters.subDepartment);
      }

      if (filters.organization) params.append('q[army_personnel_organization_cont]', filters.organization);
      if (filters.title) params.append('q[army_personnel_title_cont]', filters.title);
      if (filters.equipment) params.append('q[army_personnel_army_equipment_cont]', filters.equipment);
      if (filters.region) params.append('q[army_personnel_location_region_cont]', filters.region);
      if (filters.district) params.append('q[army_personnel_location_district_cont]', filters.district);
      if (filters.station) params.append('q[army_personnel_location_station_i_cont]', filters.station);
      if (filters.rank) params.append('q[army_personnel_rank_cont]', filters.rank);
      if (filters.status) params.append('q[army_personnel_active_status_eq]', filters.status);
      if (filters.fromDate) params.append('q[army_personnel_created_date_gteq]', filters.fromDate);
      if (filters.toDate) params.append('q[army_personnel_created_date_lteq]', filters.toDate);

      const data = await api.get(`/users?${params.toString()}`);
      if (requestId !== fetchUsersRequestId.current) return;
      setUsers(Array.isArray(data?.users) ? data.users : []);
      setTotalPages(data?.total_pages || 1);
      setTotalCount(data?.total_count || 0);
    } catch (err) {
      console.error('Failed to fetch users', err);
      setUsers([]);
      setTotalCount(0);
      setTotalPages(1);
    } finally {
      if (requestId === fetchUsersRequestId.current) setLoading(false);
    }
  };


  const handleSortSelect = (sortOption) => {
    setSortBy(sortOption);
    setDropdownOpen(false);
    setCurrentPage(1);
  };

  const handlePerPageChange = (value) => {
    setItemsPerPage(value);
    setCurrentPage(1);
  };

  const handleDelete = async (id) => {
    if (confirm('Are you sure you want to delete this user?')) {
      try {
        // The table rows are users, but the API to remove personnel expects an
        // army_personnel id. Accept either a personnel id or a user id. If a
        // personnel id is provided, call the army_personnel destroy endpoint
        // and remove the user row whose army_personnel.id matches. If only a
        // user id is provided, fall back to deleting the user resource.
        const personnelId = id && users.find(u => u.army_personnel && u.army_personnel.id === id) ? id : null;
        if (personnelId) {
          await api.delete(`/army_personnel/${personnelId}`);
          setUsers(users.filter(u => (u.army_personnel && u.army_personnel.id) !== personnelId));
        } else {
          // assume id is a user id
          await api.delete(`/users/${id}`);
          setUsers(users.filter(u => u.id !== id));
        }
      } catch (err) {
        alert('Failed to delete user');
      }
    }
  };


  const getStatusClass = (actionType) => {
    const classes = {
      1: 'leaveActive',
      0: 'leavePending',
      2: 'leaveRejected',
    };
    return classes[actionType] || 'leavePending';
  };

  const handleSelectByStatus = (status) => {
    const filteredUsers = users.filter(u => u.army_personnel?.active_status == status);
    setSelectedUsers(filteredUsers.map(u => u.id));
    setStatusDropdownOpen(false);
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedUsers(users.map(u => u.id));
    } else {
      setSelectedUsers([]);
    }
  };

  const handleSelectUser = (userId) => {
    setSelectedUsers(prev =>
      prev.includes(userId) ? prev.filter(id => id !== userId) : [...prev, userId]
    );
  };

  const handleBulkStatusUpdate = async (status) => {
    if (selectedUsers.length === 0) {
      alert('Please select users to update');
      return;
    }
    try {
      const personnelIds = selectedUsers.map(userId => {
        const user = users.find(u => u.id === userId);
        return user.army_personnel.id;
      }).filter(Boolean);

      const response = await api.post('/army_personnel/bulk_status_update', {
        personnel_ids: personnelIds,
        status: status
      });

      alert(response.data.message);
      fetchUsers();
      setSelectedUsers([]);
    } catch (err) {
      alert('Failed to update status');
    }
  };

  const handleBulkDelete = async () => {
    if (selectedUsers.length === 0) {
      alert('Please select personnel to delete');
      return;
    }

    const confirmMsg = `Are you sure you want to delete ${selectedUsers.length} selected personnel record(s)? This action cannot be undone.`;
    if (!window.confirm(confirmMsg)) {
      return;
    }

    try {
      const personnelIds = selectedUsers.map(userId => {
        const user = users.find(u => u.id === userId);
        return user?.army_personnel?.id;
      }).filter(Boolean);

      const response = await api.post('/army_personnel/bulk_delete', {
        personnel_ids: personnelIds,
        user_ids: selectedUsers
      });

      alert(response.data?.message || 'Selected personnel deleted successfully');
      setSelectedUsers([]);
      fetchUsers();
    } catch (err) {
      console.error('Bulk delete failed:', err);
      alert(err.response?.data?.error || err.response?.data?.message || 'Failed to delete selected personnel');
    }
  };

  const handleExport = () => {
    const selectedData = users.filter(u => selectedUsers.includes(u.id));
    if (selectedData.length === 0) {
      alert('Please select users to export');
      return;
    }
    const csvData = selectedData.map(user => {
      const ap = user.army_personnel;
      const row = {};

      if (exportColumns.id) row.ID = ap?.army_id || user.army_id || ap?.id || '';
      if (exportColumns.full_name) row['Full Name'] = ap?.full_name || '';
      if (exportColumns.mother_name) row['Mother Name'] = ap?.mother_name || '';
      if (exportColumns.place_of_birth) row['Place of Birth'] = ap?.place_of_birth || '';
      if (exportColumns.gender) row.Gender = ap?.gender || '';
      if (exportColumns.marital_status) row['Marital Status'] = ap?.marital_status || '';
      if (exportColumns.birth_date) row['Birth Date'] = ap?.birth_date || '';
      if (exportColumns.blood_type) row['Blood Type'] = ap?.blood_type || '';
      if (exportColumns.phone) row.Phone = ap?.phone || '';
      if (exportColumns.status) row.Status = ap?.active_status == 1 ? 'Active' : ap?.active_status == 0 ? 'Pending' : 'Rejected';
      if (exportColumns.educational_level) row['Educational Level'] = ap?.educational_level || '';
      if (exportColumns.email) row.Email = user.email;
      if (exportColumns.organization) row.Organization = ap?.organization || '';
      if (exportColumns.prev_data) row['Previous Data'] = ap?.prev_data || '';
      if (exportColumns.work_place) row['Work Place'] = ap?.work_place || '';
      if (exportColumns.address) row.Address = ap?.address || '';
      if (exportColumns.emergency_contact) row['Emergency Contact'] = ap?.emergency_contact || '';
      if (exportColumns.emergency_contact_phone) row['Emergency Phone'] = ap?.emergency_contact_phone || '';
      if (exportColumns.emergency_contact_relation) row['Emergency Relation'] = ap?.emergency_contact_relation || '';
      if (exportColumns.responsible_person_name) row['Responsible Person'] = ap?.responsible_person_name || '';
      if (exportColumns.responsible_person_phone) row['Responsible Phone'] = ap?.responsible_person_phone || '';
      if (exportColumns.army_type) row['Army Type'] = ap?.army_type?.name || '';
      if (exportColumns.army_department) row['Army Department'] = ap?.department?.name || '';
      if (exportColumns.sub_department) row['Sub Department'] = ap?.sub_department?.name || '';
      if (exportColumns.rank) row.Rank = ap?.rank || '';
      if (exportColumns.title) row.Title = ap?.title || '';
      if (exportColumns.bank_account) row['Bank Account'] = ap?.bank_account || '';
      if (exportColumns.salary_usd) row['Salary (USD)'] = ap?.salary_usd || '';
      if (exportColumns.allowance_usd) row['Allowance (USD)'] = ap?.allowance_usd || '';
      if (exportColumns.training) row.Training = ap?.training || '';
      if (exportColumns.remarks) row.Remarks = ap?.remarks || '';
      if (exportColumns.army_equipment) row['Army Equipment'] = ap?.army_equipment || '';
      if (exportColumns.district) row.District = ap?.location?.district || '';
      if (exportColumns.region) row.Region = ap?.location?.region || '';
      if (exportColumns.station) row.Station = ap?.location?.station || '';
      if (exportColumns.biometric_enrolled_count) row['Biometric Enrolled Count'] = ap?.biometric_enrolled_count || 0;
      if (exportColumns.fingerprints_data) row.Fingerprints = ap?.biometric_fingerprint ? 'Yes' : 'No';
      if (exportColumns.synced_to_web) row['Synced to Web'] = user.created_at ? 'Yes' : 'No';
      if (exportColumns.sync_date) row['Sync Date'] = ap?.updated_at ? new Date(ap.updated_at).toLocaleDateString() : '';
      if (exportColumns.created_at) row['Created Date'] = ap?.created_date ? new Date(ap.created_date).toLocaleDateString() : '';
      return row;
    });

    const csv = [
      Object.keys(csvData[0]).join(','),
      ...csvData.map(row => Object.values(row).map(v => `"${v}"`).join(','))
    ].join('\n');

    const blob = new Blob([csv], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'personnel_export.csv';
    a.click();
    setShowExportModal(false);
  };


  return (
    <>
      <div className="mb_20">
        <div
          style={{
            backgroundColor: '#ffffff',
            border: '1px solid #e2e8f0',
            borderRadius: '8px',
            padding: '12px 20px',
            boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
            marginBottom: '16px'
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <i className="fa fa-filter" style={{ color: '#1E40AF', fontSize: '15px' }}></i>
              <span style={{ fontWeight: '600', fontSize: '14px', color: '#0f172a' }}>Search & Filter Personnel</span>
              {Object.values(filters).filter(Boolean).length > 0 && (
                <span className="badge" style={{ backgroundColor: '#1E40AF', color: '#fff', fontSize: '11px', padding: '2px 8px', borderRadius: '10px' }}>
                  {Object.values(filters).filter(Boolean).length} Active
                </span>
              )}
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              {Object.values(filters).filter(Boolean).length > 0 && (
                <button
                  type="button"
                  className="btn btn-sm btn-light"
                  onClick={handleClearFilters}
                  style={{ fontSize: '12px', color: '#dc2626', border: '1px solid #fecdd3', backgroundColor: '#fef2f2' }}
                >
                  Clear All
                </button>
              )}
              <button
                type="button"
                className="btn btn-sm"
                onClick={() => setShowFilters(!showFilters)}
                style={{
                  fontSize: '13px',
                  fontWeight: '600',
                  color: '#1E40AF',
                  backgroundColor: '#dbeafe',
                  border: 'none',
                  padding: '6px 14px',
                  borderRadius: '6px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  cursor: 'pointer'
                }}
              >
                {showFilters ? '▲ Hide Filters' : '▼ Show Filters'}
              </button>
            </div>
          </div>

          {showFilters && (
            <div style={{ marginTop: '16px', paddingTop: '16px', borderTop: '1px solid #f1f5f9' }}>
              <ul className="dFlex pt_8 pb_8 formFieldsWrap">
                <li className="w_1_3">
                  <div className="formInpt">
                    <label className="mb_8">Email</label>
                    <input type="text" placeholder="Email" value={filters.email} onChange={(e) => handleFilterChange('email', e.target.value)} />
                  </div>
                </li>
                <li className="w_1_3">
                  <div className="formInpt">
                    <label className="mb_8">Personnel Name</label>
                    <input type="text" placeholder="Personnel Name" value={filters.full_name} onChange={(e) => handleFilterChange('full_name', e.target.value)} />
                  </div>
                </li>
                <li className="w_1_3">
                  <div className="formInpt">
                    <label className="mb_10">Phone</label>
                    <input type="text" placeholder="Phone" value={filters.phone} onChange={(e) => handleFilterChange('phone', e.target.value)} />
                  </div>
                </li>
                <li className="w_1_3">
                  <div className="formInpt">
                    <label className="mb_8">Department</label>
                    <select
                      value={filters.department}
                      onChange={(e) => handleDepartmentFilterChange(e.target.value)}
                    >
                      <option value="">All Departments</option>
                      {filteredDepartments.map(dept => (
                        <option key={dept.id || dept.name} value={dept.somali_name || dept.name}>
                          {dept.somali_name || dept.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </li>
                <li className="w_1_3">
                  <div className="formInpt">
                    <label className="mb_8">Sub Department</label>
                    <select
                      value={filters.subDepartment}
                      onChange={(e) => handleSubDepartmentFilterChange(e.target.value)}
                      disabled={!filters.department}
                    >
                      <option value="">
                        {!filters.department ? '-- Select Department First --' : 'All Sub-Departments'}
                      </option>
                      {filteredSubDepartments.map(subDept => (
                        <option key={subDept.id || subDept.name} value={subDept.somali_name || subDept.name}>
                          {subDept.somali_name || subDept.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </li>
                <li className="w_1_3">
                  <div className="formInpt">
                    <label className="mb_8">Organization</label>
                    <input type="text" placeholder="Organization" value={filters.organization} onChange={(e) => handleFilterChange('organization', e.target.value)} />
                  </div>
                </li>
                <li className="w_1_3">
                  <div className="formInpt">
                    <label className="mb_8">Title</label>
                    <input type="text" placeholder="Title" value={filters.title} onChange={(e) => handleFilterChange('title', e.target.value)} />
                  </div>
                </li>
                <li className="w_1_3">
                  <div className="formInpt">
                    <label className="mb_8">Equipment</label>
                    <input type="text" placeholder="Equipment" value={filters.equipment} onChange={(e) => handleFilterChange('equipment', e.target.value)} />
                  </div>
                </li>
                {/* <li className="w_1_3">
                  <div className="formInpt">
                    <label className="mb_8">Region</label>
                    <select value={filters.region} onChange={(e) => handleFilterChange('region', e.target.value)}>
                      <option value="">All Regions</option>
                      {[...new Set(locations.map(l => l.region))].filter(Boolean).map(region => (
                        <option key={region} value={region}>{region}</option>
                      ))}
                    </select>
                  </div>
                </li>
                <li className="w_1_3">
                  <div className="formInpt">
                    <label className="mb_8">District</label>
                    <select value={filters.district} onChange={(e) => handleFilterChange('district', e.target.value)}>
                      <option value="">All Districts</option>
                      {[...new Set(locations.map(l => l.district))].filter(Boolean).map(district => (
                        <option key={district} value={district}>{district}</option>
                      ))}
                    </select>
                  </div>
                </li> */}
                <li className="w_1_3">
                  <div className="formInpt">
                    <label className="mb_8">Station</label>
                    <input type="text" placeholder="Station" value={filters.station} onChange={(e) => handleFilterChange('station', e.target.value)} />
                  </div>
                </li>
                <li className="w_1_3">
                  <div className="formInpt">
                    <label className="mb_8">Rank</label>
                    <input type="text" placeholder="Rank" value={filters.rank} onChange={(e) => handleFilterChange('rank', e.target.value)} />
                  </div>
                </li>
                <li className="w_1_3">
                  <div className="formInpt">
                    <label className="mb_8">Status</label>
                    <select value={filters.status} onChange={(e) => handleFilterChange('status', e.target.value)}>
                      <option value="">All Status</option>
                      <option value="0">Pending</option>
                      <option value="1">Active</option>
                      <option value="2">Rejected</option>
                    </select>
                  </div>
                </li>
                <li className="w_1_3">
                  <div className="formInpt hasDatePicker">
                    <label className="mb_8">From Date</label>
                    <input
                      type="text"
                      id="fromDateFilter"
                      className="customDatepicker"
                      value={filters.fromDate}
                      onChange={(e) => handleFilterChange('fromDate', e.target.value)}
                      placeholder="YY-MM-DD"
                    />
                  </div>
                </li>
                <li className="w_1_3">
                  <div className="formInpt hasDatePicker">
                    <label className="mb_8">To Date</label>
                    <input
                      type="text"
                      id="toDateFilter"
                      className="customDatepicker"
                      value={filters.toDate}
                      onChange={(e) => handleFilterChange('toDate', e.target.value)}
                      placeholder="YY-MM-DD"
                    />
                  </div>
                </li>
              </ul>
            </div>
          )}
        </div>
      </div>
      {/* Summary Metric Cards to reduce raw table dominance */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '16px', marginBottom: '20px' }}>
        <div className="card-dense hover-lift" style={{ borderLeft: '4px solid #1E40AF' }}>
          <div style={{ fontSize: '12px', fontWeight: '600', color: '#64748b', textTransform: 'uppercase' }}>Total Personnel</div>
          <div style={{ fontSize: '24px', fontWeight: '700', color: '#0f172a', marginTop: '4px' }}>{totalCount}</div>
        </div>
        <div className="card-dense hover-lift" style={{ borderLeft: '4px solid #16A34A' }}>
          <div style={{ fontSize: '12px', fontWeight: '600', color: '#64748b', textTransform: 'uppercase' }}>Active Force Members</div>
          <div style={{ fontSize: '24px', fontWeight: '700', color: '#16A34A', marginTop: '4px' }}>
            {users.filter(u => u.army_personnel?.active_status == 1).length}
          </div>
        </div>
        <div className="card-dense hover-lift" style={{ borderLeft: '4px solid #F59E0B' }}>
          <div style={{ fontSize: '12px', fontWeight: '600', color: '#64748b', textTransform: 'uppercase' }}>Pending / In Review</div>
          <div style={{ fontSize: '24px', fontWeight: '700', color: '#F59E0B', marginTop: '4px' }}>
            {users.filter(u => u.army_personnel?.active_status == 0).length}
          </div>
        </div>
      </div>

      <div className="mb_40 baseTableWrap card-dense" style={{ padding: '20px' }}>
        <div className="dFlex baseTableHd mb_16" style={{ alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '12px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <h2 className="txt20 fwMedium colorBlack" style={{ margin: 0 }}>Personnel Management</h2>
            {subView === 'military' && <span className="badge" style={{ backgroundColor: '#dbeafe', color: '#1E40AF', padding: '4px 8px', borderRadius: '4px', fontSize: '12px', fontWeight: '600' }}>Puntland Darawiish Force</span>}
            {subView === 'police' && <span className="badge" style={{ backgroundColor: '#dbeafe', color: '#1E40AF', padding: '4px 8px', borderRadius: '4px', fontSize: '12px', fontWeight: '600' }}>Puntland Police Force</span>}
            {subView === 'discipline' && <span className="badge" style={{ backgroundColor: '#dbeafe', color: '#1E40AF', padding: '4px 8px', borderRadius: '4px', fontSize: '12px', fontWeight: '600' }}>Custodial Corps (Asluubta)</span>}
          </div>
          <div className="dFlex baseTableTR" style={{ gap: '8px' }}>
            {!isPersonnelViewer && (
              <button className="btn btn-primary" onClick={() => setShowBulkModal(true)} style={{ backgroundColor: '#1E40AF', borderColor: '#1E40AF' }}>
                Bulk Update
              </button>
            )}
            <button className="btn btn-secondary" onClick={() => setRefreshKey(k => k + 1)} title="Refresh list" style={{ marginLeft: '4px' }}>
              ↻ Refresh
            </button>
            {selectedUsers.length > 0 && (
              <>
                {!isPersonnelViewer && (
                  <div className="dropdown dropdownSortBy">
                    <button className="dropdown-toggle" type="button" onClick={() => setStatusDropdownOpen(!statusDropdownOpen)}>
                      Update Status
                    </button>
                    <ul className={`dropdown-menu ${statusDropdownOpen ? 'show' : ''}`}>
                      <li><a className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); handleBulkStatusUpdate(1); setStatusDropdownOpen(false); }}>Set Active</a></li>
                      <li><a className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); handleBulkStatusUpdate(0); setStatusDropdownOpen(false); }}>Set Pending</a></li>
                      <li><a className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); handleBulkStatusUpdate(2); setStatusDropdownOpen(false); }}>Set Rejected</a></li>
                    </ul>
                  </div>
                )}
                <button className="btn btn-primary" onClick={() => setShowExportModal(true)} style={{ backgroundColor: '#1E40AF', borderColor: '#1E40AF' }}>
                  Export Selected
                </button>
                {!isPersonnelViewer && (
                  <button className="btn btn-danger" onClick={handleBulkDelete} style={{ backgroundColor: '#DC2626', borderColor: '#DC2626', color: '#ffffff', marginLeft: '4px' }}>
                    Bulk Delete ({selectedUsers.length})
                  </button>
                )}
              </>
            )}

            <div className="dropdown dropdownStatus" style={{ display: 'inline-block', marginLeft: '5px' }}>
              <button className="dropdown-toggle form-control" type="button" onClick={() => setSelectByStatusDropdownOpen(!selectByStatusDropdownOpen)} style={{ fontSize: '14px', padding: '4px 8px' }}>
                Select Status
              </button>
              <ul className={`dropdown-menu ${selectByStatusDropdownOpen ? 'show' : ''}`}>
                <li><a className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); handleSelectByStatus(1); }}>Active</a></li>
                <li><a className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); handleSelectByStatus(0); }}>Pending</a></li>
                <li><a className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); handleSelectByStatus(2); }}>Rejected</a></li>
              </ul>
            </div>
            <div className="dropdown dropdownSortBy">
              <button
                className="dropdown-toggle"
                type="button"
                onClick={() => setDropdownOpen(!dropdownOpen)}
              >
                {t('sort_by')}
              </button>
              <ul className={`dropdown-menu ${dropdownOpen ? 'show' : ''}`}>
                <li><a className="dropdown-item" href="#" onClick={() => handleSortSelect('email-asc')}>Email A-Z</a></li>
                <li><a className="dropdown-item" href="#" onClick={() => handleSortSelect('email-desc')}>Email Z-A</a></li>
                <li><a className="dropdown-item" href="#" onClick={() => handleSortSelect('created_at-desc')}>Newest First</a></li>
                <li><a className="dropdown-item" href="#" onClick={() => handleSortSelect('created_at-asc')}>Oldest First</a></li>
              </ul>
            </div>
            <div className="dropdown dropdownSortBy">
              <button className="dropdown-toggle" type="button" onClick={() => setPerPageDropdownOpen(!perPageDropdownOpen)}>
                Show: {itemsPerPage === 'all' ? 'All' : itemsPerPage}
              </button>
              <ul className={`dropdown-menu ${perPageDropdownOpen ? 'show' : ''}`}>
                <li><a className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); handlePerPageChange(25); setPerPageDropdownOpen(false); }}>25</a></li>
                <li><a className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); handlePerPageChange(100); setPerPageDropdownOpen(false); }}>100</a></li>
                <li><a className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); handlePerPageChange(200); setPerPageDropdownOpen(false); }}>200</a></li>
                <li><a className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); handlePerPageChange(300); setPerPageDropdownOpen(false); }}>300</a></li>
                <li><a className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); handlePerPageChange('all'); setPerPageDropdownOpen(false); }}>All</a></li>
              </ul>
            </div>
          </div>
        </div>
        <div className="baseTableContainer" style={{ maxHeight: '650px', overflowY: 'auto' }}>
          <table className="baseTable table-compact">
            <thead>
              <tr>
                <th className="table-sticky-header"><input type="checkbox" onChange={handleSelectAll} checked={selectedUsers.length === users.length && users.length > 0} />
                </th>
                <th className="table-sticky-header">Email</th>
                <th className="table-sticky-header">Army Rank</th>
                <th className="table-sticky-header">Personnel Name</th>
                <th className="table-sticky-header">Phone</th>
                <th className="table-sticky-header">Bank Name</th>
                <th className="table-sticky-header">Bank Account</th>
                <th className="table-sticky-header">Army Type</th>
                <th className="table-sticky-header">{t('department')}</th>
                <th className="table-sticky-header">Sub Department</th>
                <th className="table-sticky-header">Organization</th>
                <th className="table-sticky-header">Fingerprint Status</th>
                <th className="table-sticky-header">{t('created_date')}</th>
                <th className="table-sticky-header">{t('sync_date')}</th>
                <th className="table-sticky-header">{t('status')}</th>
                <th className="table-sticky-header" style={{ minWidth: "150px" }}>{t('actions')}</th>
              </tr>
            </thead>
            <tbody>
              {loading && users.length === 0 ? (
                <tr>
                  <td colSpan="16" style={{ textAlign: 'center', padding: '20px' }}>
                    Loading...
                  </td>
                </tr>
              ) : users.length > 0 ? (
                users.map((user) => (
                  <tr key={user.id}>
                    <td><input type="checkbox" checked={selectedUsers.includes(user.id)} onChange={() => handleSelectUser(user.id)} /></td>
                    <td>{user.email}</td>
                    <td>{user.army_personnel?.rank || 'N/A'}</td>
                    <td className="text-wrap">{user.army_personnel?.full_name || 'Not assigned'}</td>
                    <td>{user.army_personnel?.phone || 'N/A'}</td>
                    <td>{user.army_personnel?.bank_name || 'Bank'}</td>
                    <td>{user.army_personnel?.bank_account || 'N/A'}</td>
                    <td>{t(`${user.army_personnel?.army_type?.name}`) || 'N/A'}</td>
                    <td>{toSomaliDept(user.army_personnel?.department?.name) || 'N/A'}</td>
                    <td>{toSomaliDept(user.army_personnel?.sub_department?.name) || 'N/A'}</td>
                    <td>{user.army_personnel?.organization || 'N/A'}</td>
                    <td>{user.army_personnel?.biometric_fingerprint ? 'Enrolled' : 'Not Enrolled'}</td>
                    <td>{user.army_personnel?.created_date ? new Date(user.army_personnel.created_date).toLocaleDateString() : ''}</td>
                    <td>{user.army_personnel?.updated_at ? new Date(user.army_personnel.updated_at).toLocaleDateString() : ''}</td>
                    <td>
                      <span className={getStatusClass(user.army_personnel?.active_status)}>
                        {user.army_personnel?.active_status == 0 ? 'Pending' : user.army_personnel?.active_status == 1 ? 'Active' : 'Rejected'}
                      </span>
                    </td>
                    <td style={{ position: 'relative' }}>
                      <div className="dropdown actions-dropdown-container" style={{ position: 'relative', display: 'inline-block' }}>
                        <button
                          className="btn btn-sm btn-outline-secondary"
                          type="button"
                          onClick={(e) => {
                            e.stopPropagation();
                            setOpenActionDropdownId(openActionDropdownId === user.id ? null : user.id);
                          }}
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '6px',
                            fontWeight: '600',
                            fontSize: '13px',
                            padding: '4px 12px',
                            borderRadius: '6px',
                            backgroundColor: '#f8fafc',
                            border: '1px solid #cbd5e1',
                            color: '#1e293b',
                            cursor: 'pointer',
                            whiteSpace: 'nowrap'
                          }}
                        >
                          <span>Actions</span>
                          <span style={{ fontSize: '10px', marginLeft: '2px' }}>▼</span>
                        </button>
                        {openActionDropdownId === user.id && (
                          <ul
                            className="dropdown-menu show"
                            style={{
                              position: 'absolute',
                              right: 0,
                              top: '100%',
                              zIndex: 1050,
                              minWidth: '150px',
                              boxShadow: '0 10px 25px -5px rgba(0,0,0,0.15), 0 8px 10px -6px rgba(0,0,0,0.1)',
                              borderRadius: '8px',
                              border: '1px solid #e2e8f0',
                              padding: '6px 0',
                              backgroundColor: '#ffffff',
                              marginTop: '4px'
                            }}
                          >
                            <li>
                              <button
                                className="dropdown-item"
                                style={{ padding: '8px 16px', fontSize: '13px', display: 'flex', alignItems: 'center', gap: '8px', width: '100%', textAlign: 'left', border: 'none', background: 'none', cursor: 'pointer' }}
                                onClick={() => {
                                  setViewModalUser(user);
                                  setShowViewModal(true);
                                  setOpenActionDropdownId(null);
                                }}
                              >
                                <img src="/images/view.png" alt="" style={{ width: '14px', height: '14px', objectFit: 'contain' }} /> View
                              </button>
                            </li>
                            {!isPersonnelViewer && user.army_personnel && (
                              <li>
                                <button
                                  className="dropdown-item"
                                  style={{ padding: '8px 16px', fontSize: '13px', display: 'flex', alignItems: 'center', gap: '8px', width: '100%', textAlign: 'left', border: 'none', background: 'none', cursor: 'pointer' }}
                                  onClick={() => {
                                    onNavigate(`edit-personnel-${subView}`, user.id, user.army_personnel.id);
                                    setOpenActionDropdownId(null);
                                  }}
                                >
                                  <img src="/images/edit.png" alt="" style={{ width: '14px', height: '14px', objectFit: 'contain' }} /> Edit
                                </button>
                              </li>
                            )}
                            <li>
                              <button
                                className="dropdown-item"
                                style={{ padding: '8px 16px', fontSize: '13px', display: 'flex', alignItems: 'center', gap: '8px', width: '100%', textAlign: 'left', border: 'none', background: 'none', cursor: 'pointer' }}
                                onClick={() => {
                                  handleShowId(user);
                                  setOpenActionDropdownId(null);
                                }}
                              >
                                <img src="/images/view.png" alt="" style={{ width: '14px', height: '14px', objectFit: 'contain' }} /> ID Card
                              </button>
                            </li>
                            {!isPersonnelViewer && (
                              <li style={{ borderTop: '1px solid #f1f5f9', marginTop: '4px', paddingTop: '4px' }}>
                                <button
                                  className="dropdown-item text-danger"
                                  style={{ padding: '8px 16px', fontSize: '13px', display: 'flex', alignItems: 'center', gap: '8px', width: '100%', textAlign: 'left', border: 'none', background: 'none', cursor: 'pointer', color: '#dc2626' }}
                                  onClick={() => {
                                    handleDelete(user.army_personnel?.id || user.id);
                                    setOpenActionDropdownId(null);
                                  }}
                                >
                                  <img src="/images/delete.png" alt="" style={{ width: '14px', height: '14px', objectFit: 'contain' }} /> Delete
                                </button>
                              </li>
                            )}
                          </ul>
                        )}
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="13" style={{ textAlign: 'center', padding: '20px' }}>
                    No users found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <CommonModal isOpen={showIdModal} onClose={() => setShowIdModal(false)} title="ID Card Preview" size="xl">
          <div style={{ marginBottom: '15px', display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
            <button className="btn btn-sm btn-primary" onClick={handlePrint} style={{ marginRight: '5px' }}>Print</button>
            <button className="btn btn-sm btn-success" onClick={handleDownload}>Download PDF</button>
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', justifyContent: 'center' }}>
            <div style={{ border: '1px solid #ddd', padding: '10px', borderRadius: '4px', flex: '1 1 350px', maxWidth: '100%', overflowX: 'auto' }}>
              <h4 style={{ textAlign: 'center', marginTop: 0 }}>Front</h4>
              {idCardAssignment && <DynamicIdCard assignment={idCardAssignment} side="front" />}
            </div>
            <div style={{ border: '1px solid #ddd', padding: '10px', borderRadius: '4px', flex: '1 1 350px', maxWidth: '100%', overflowX: 'auto' }}>
              <h4 style={{ textAlign: 'center', marginTop: 0 }}>Back</h4>
              {idCardAssignment && <DynamicIdCard assignment={idCardAssignment} side="back" />}
            </div>
          </div>
        </CommonModal>
        {showBulkModal && (
          <BulkUpdateModal
            onClose={() => setShowBulkModal(false)}
            onSubmit={handleBulkSubmit}
          />
        )}
        {showViewModal && viewModalUser && (
          <PersonnelViewModal
            isOpen={showViewModal}
            onClose={() => setShowViewModal(false)}
            user={viewModalUser}
            api={api}
          />
        )}
        {showExportModal && (
          <CommonModal isOpen={showExportModal} onClose={() => setShowExportModal(false)} title="Select Columns to Export">
            <div className="modal-body" style={{ maxHeight: '500px', overflowY: 'auto' }}>
              <div style={{ marginBottom: '10px' }}>
                <button className="btn btn-sm btn-secondary" onClick={() => setExportColumns(Object.keys(exportColumns).reduce((acc, key) => ({ ...acc, [key]: true }), {}))}>Select All</button>
                <button className="btn btn-sm btn-secondary" onClick={() => setExportColumns(Object.keys(exportColumns).reduce((acc, key) => ({ ...acc, [key]: false }), {}))}>Deselect All</button>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '10px' }}>
                {Object.keys(exportColumns).map(col => (
                  <label key={col}>
                    <input type="checkbox" checked={exportColumns[col]} onChange={(e) => setExportColumns({ ...exportColumns, [col]: e.target.checked })} />
                    {' '}{col.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}
                  </label>
                ))}
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-primary" onClick={handleExport}>Export</button>
            </div>
          </CommonModal>
        )}
        {itemsPerPage !== 'all' && <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={setCurrentPage} />}

      </div>
    </>
  );
};

export default PersonnelManagement;
